"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VehicleSlidingDoors = exports.VehicleCategory = exports.VehicleClass = exports.VehicleUsageType = exports.VehicleAvailabilityShort = exports.VehicleDrivetrain = exports.VehicleTransmission = exports.VehicleInventoryStateShort = exports.VehicleTransmissionShort = exports.VehicleFuelType = exports.VehicleInteriorTypeTranslation = exports.VehicleInteriorColorTranslation = exports.VehicleExteriorColorTranslation = void 0;
/* eslint-disable max-classes-per-file */
const core_1 = require("@angular/core");
const enums_1 = require("../../../@shared-types/vehicle/enums");
let VehicleExteriorColorTranslation = class VehicleExteriorColorTranslation {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleExteriorColorTranslation.prototype, "color", void 0);
VehicleExteriorColorTranslation = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-exterior-color-translation',
        template: `
    <ng-container>
    {color, select,
      RED {Rot}
      BEIGE {Beige}
      BLACK {Schwarz}
      BLUE {Blau}
      BROWN {Braun}
      GOLD {Gold}
      GREEN {Grün}
      GREY {Grau}
      ORANGE {Orange}
      PURPLE {Lila}
      SILVER {Silber}
      WHITE {Weiß}
      YELLOW {Gelb}
      Other {Sonstige}
    }
  </ng-container>
  `,
    })
], VehicleExteriorColorTranslation);
exports.VehicleExteriorColorTranslation = VehicleExteriorColorTranslation;
let VehicleInteriorColorTranslation = class VehicleInteriorColorTranslation {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleInteriorColorTranslation.prototype, "color", void 0);
VehicleInteriorColorTranslation = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-interior-color-translation',
        template: `
    <ng-container>
    {color, select,
      BEIGE {Beige}
      BLACK {Schwarz}
      BROWN {Braun}
      GREY {Grau}
      RED {Rot}
      BLUE {Blau}
      OTHER {Sonstige}
    }
  </ng-container>
  `,
    })
], VehicleInteriorColorTranslation);
exports.VehicleInteriorColorTranslation = VehicleInteriorColorTranslation;
let VehicleInteriorTypeTranslation = class VehicleInteriorTypeTranslation {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], VehicleInteriorTypeTranslation.prototype, "interior", void 0);
VehicleInteriorTypeTranslation = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-interior-type-translation',
        template: `
    <ng-container>
    {interior, select,
      ALCANTARA {Alcantara}
      FABRIC {Stoff}
      LEATHER {Leder}
      PART_LEATHER {Teilleder}
      FAUX_LEATHER {Kunstleder}
      VELOUR {Velours}
      OTHER {Sonstige}
    }
  </ng-container>
  `,
    })
], VehicleInteriorTypeTranslation);
exports.VehicleInteriorTypeTranslation = VehicleInteriorTypeTranslation;
let VehicleFuelType = class VehicleFuelType {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_d = typeof enums_1.EFuelType !== "undefined" && enums_1.EFuelType) === "function" ? _d : Object)
], VehicleFuelType.prototype, "fuelType", void 0);
VehicleFuelType = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-fuel-type',
        template: `
    <ng-container>
    {fuelType, select,
      CNG {Erdgas}
      DIESEL {Diesel}
      ELECTRICITY {Elektrisch}
      ETHANOL {Ethanol}
      HYBRID_DIESEL_MILD {Mild-Hybrid Diesel}
      HYBRID_DIESEL_PLUGIN {Plug-in-Hybrid Diesel}
      HYBRID_PETROL_MILD {Mild-Hybrid Benzin}
      HYBRID_PETROL_PLUGIN {Plug-in-Hybrid Benzin}
      HYBRID_FULL {Voll-Hybrid}
      HYDROGEN {Wasserstoff}
      LPG {LPG}
      PETROL {Benzin}
      OTHER {Sonstiger Kraftstoff}
    }
  </ng-container>
  `,
    })
], VehicleFuelType);
exports.VehicleFuelType = VehicleFuelType;
let VehicleTransmissionShort = class VehicleTransmissionShort {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_e = typeof enums_1.ETransmissionType !== "undefined" && enums_1.ETransmissionType) === "function" ? _e : Object)
], VehicleTransmissionShort.prototype, "transmission", void 0);
VehicleTransmissionShort = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-transmission-short',
        template: `
    <ng-container>
    {transmission, select,
      AUTOMATIC {AT}
      SEMI_AUTO {MTA}
      MANUAL {MT}
    }
  </ng-container>
  `,
    })
], VehicleTransmissionShort);
exports.VehicleTransmissionShort = VehicleTransmissionShort;
let VehicleInventoryStateShort = class VehicleInventoryStateShort {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_f = typeof enums_1.EInventoryState !== "undefined" && enums_1.EInventoryState) === "function" ? _f : Object)
], VehicleInventoryStateShort.prototype, "inventoryState", void 0);
VehicleInventoryStateShort = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-inventory-state-short',
        template: `
    <ng-container>
    {inventoryState, select,
      ORDERED {Vorlauf}
      STOCK {Lager}
      SOLD {Ausgeliefert}
    }
  </ng-container>
  `,
    })
], VehicleInventoryStateShort);
exports.VehicleInventoryStateShort = VehicleInventoryStateShort;
let VehicleTransmission = class VehicleTransmission {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_g = typeof enums_1.ETransmissionType !== "undefined" && enums_1.ETransmissionType) === "function" ? _g : Object)
], VehicleTransmission.prototype, "transmission", void 0);
VehicleTransmission = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-transmission',
        template: `
    <ng-container>
    {transmission, select,
      AUTOMATIC {Automatikgetriebe}
      SEMI_AUTO {Halbautomatikgetriebe}
      MANUAL {Manuelles Getriebe}
    }
  </ng-container>
  `,
    })
], VehicleTransmission);
exports.VehicleTransmission = VehicleTransmission;
let VehicleDrivetrain = class VehicleDrivetrain {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_h = typeof enums_1.EDrivetrain !== "undefined" && enums_1.EDrivetrain) === "function" ? _h : Object)
], VehicleDrivetrain.prototype, "drivetrain", void 0);
VehicleDrivetrain = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-drivetrain',
        template: `
    <ng-container>
    {drivetrain, select,
      A {Allradantrieb}
      F {Vorderradantrieb}
      B {Hinterradantrieb}
    }
  </ng-container>
  `,
    })
], VehicleDrivetrain);
exports.VehicleDrivetrain = VehicleDrivetrain;
let VehicleAvailabilityShort = class VehicleAvailabilityShort {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_j = typeof enums_1.EDrivetrain !== "undefined" && enums_1.EDrivetrain) === "function" ? _j : Object)
], VehicleAvailabilityShort.prototype, "availability", void 0);
VehicleAvailabilityShort = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-availability-short',
        template: `
    <ng-container>
    {availability, select,
      A {Verfügbar}
      S {Verkauft}
      R {Reserviert}
      E {Event}
    }
  </ng-container>
  `,
    })
], VehicleAvailabilityShort);
exports.VehicleAvailabilityShort = VehicleAvailabilityShort;
let VehicleUsageType = class VehicleUsageType {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_k = typeof enums_1.EVehicleUsage !== "undefined" && enums_1.EVehicleUsage) === "function" ? _k : Object)
], VehicleUsageType.prototype, "usage", void 0);
VehicleUsageType = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-usage',
        template: `
    <ng-container>
    {usage, select,
      N {Neufahrzeug}
      D {Vorführfahrzeug}
      S {Tageszulassung}
      U {Gebrauchtfahrzeug}
      E {Dienstwagen}
      R {Vermietfahrzeug}
    }
  </ng-container>
  `,
    })
], VehicleUsageType);
exports.VehicleUsageType = VehicleUsageType;
let VehicleClass = class VehicleClass {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_l = typeof enums_1.EVehicleClass !== "undefined" && enums_1.EVehicleClass) === "function" ? _l : Object)
], VehicleClass.prototype, "class", void 0);
VehicleClass = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-class',
        template: `
    <ng-container>
    {class, select,
      CAR {Auto}
      MOTOBIKE {Motorrad}
      BUS {Bus}
      MOTORHOME {Wohnmobil}
      TRUCK_OVER_7500 {Lkw über 7,5t}
      TRUCK_UPTO_7500 {Lkw bis 7,5t}
    }
  </ng-container>
  `,
    })
], VehicleClass);
exports.VehicleClass = VehicleClass;
let VehicleCategory = class VehicleCategory {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_m = typeof enums_1.EVehicleCategory !== "undefined" && enums_1.EVehicleCategory) === "function" ? _m : Object)
], VehicleCategory.prototype, "category", void 0);
VehicleCategory = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-class',
        template: `
    <ng-container>
    {category, select,
      CONVERTIBLE {Cabriolet}
      ESTATE {Kombi}
      LIMOUSINE {Limousine}
      OFFROAD {Offroad}
      SMALL {Kleinwagen}
      VAN {Van}
    }
  </ng-container>
  `,
    })
], VehicleCategory);
exports.VehicleCategory = VehicleCategory;
let VehicleSlidingDoors = class VehicleSlidingDoors {
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", typeof (_o = typeof enums_1.ESlidingDoors !== "undefined" && enums_1.ESlidingDoors) === "function" ? _o : Object)
], VehicleSlidingDoors.prototype, "doors", void 0);
VehicleSlidingDoors = __decorate([
    (0, core_1.Component)({
        selector: 'vehicle-sliding-doors',
        template: `
    <ng-container>
    {doors, select,
      LM {Links (manuell)}
      LA {Links (elektrisch)}
      RM {Rechts (manuell)}
      RA {Rechts (elektrisch)}
      BM {Beide Seiten (manuell)}
      BA {Beide Seiten (elektrisch)}
    }
  </ng-container>
  `,
    })
], VehicleSlidingDoors);
exports.VehicleSlidingDoors = VehicleSlidingDoors;
